"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[174],{

/***/ 90231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony export ButtonMemo */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _helpers_sitemap_isInternalLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49853);
/* harmony import */ var _images_IconLoader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64162);
/* harmony import */ var _loaders_Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58998);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76609);










var variantClasses = {
    primary: "pyxis-btn-primary",
    secondary: "pyxis-btn-secondary",
    tertiary: "pyxis-btn-tertiary",
    brand: "pyxis-btn-brand",
    ghost: "pyxis-btn-ghost",
    white: "pyxis-btn-white"
};
var sizeClasses = {
    sm: "pyxis-btn-small",
    md: "pyxis-btn-medium",
    lg: "pyxis-btn-large",
    xl: "pyxis-btn-huge"
};
var iconSizeClasses = {
    sm: "w-4 h-4",
    md: "w-4 h-4",
    lg: "w-4 h-4",
    xl: "w-4 h-4"
};
var iconOnlySizeClasses = {
    sm: "w-10 h-10 md:w-10 md:h-10",
    md: "w-10 h-10 md:w-11 md:h-11",
    lg: "w-10 h-10 md:w-11 md:h-11",
    xl: "w-10 h-10 md:w-11 md:h-11"
};
var Button = function(props) {
    if ((0,_helpers_sitemap_isInternalLink__WEBPACK_IMPORTED_MODULE_6__/* .isInternalLink */ .F)(props.href)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .r, {
            href: props.href,
            locale: props.language,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonInner, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
                as: "span"
            }))
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonInner, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props));
};
var ButtonMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(Button)));
var ButtonInner = function(param) {
    var _as = param.as, as = _as === void 0 ? "a" : _as, _label = param.label, label = _label === void 0 ? "" : _label, href = param.href, onClick = param.onClick, target = param.target, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = param.size, size = _size === void 0 ? "lg" : _size, icon = param.icon, _iconPosition = param.iconPosition, iconPosition = _iconPosition === void 0 ? "after" : _iconPosition, _compact = param.compact, compact = _compact === void 0 ? false : _compact, ariaLabel = param.ariaLabel, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _download = param.download, download = _download === void 0 ? false : _download, _hideLabel = param.hideLabel, hideLabel = _hideLabel === void 0 ? false : _hideLabel, _stretch = param.stretch, stretch = _stretch === void 0 ? false : _stretch, _alt = param.alt, alt = _alt === void 0 ? false : _alt;
    var Element = as === "submit" ? "button" : as;
    var props = {
        type: null,
        href: null,
        target: null,
        download: null,
        title: null,
        disabled: null
    };
    if (target === "_blank") {
        icon = "external-link";
        iconPosition = "after";
    }
    if (hideLabel) {
        ariaLabel = props.title = label;
        label = "";
    }
    label = label || "";
    iconPosition = iconPosition || "after";
    // prevent orphan icon by adding first / last word to icon
    var labelWords = label === null || label === void 0 ? void 0 : label.split(" ");
    if (as === "button") {
        props.type = "button";
    }
    if (as === "submit") {
        props.type = "button";
    }
    if (as === "a") {
        props.href = href;
        props.target = target;
    }
    if (download) {
        var ref;
        props.download = true;
        if (((ref = props.href) === null || ref === void 0 ? void 0 : ref.indexOf(".sanity.io")) > -1) props.href = "".concat(props.href, "?dl");
    }
    if (disabled) {
        props.disabled = "disabled";
    }
    var handleClick = function(e) {
        return disabled ? function() {} : onClick ? onClick(e) : function() {};
    };
    var ButtonIcon = icon ? function(param) {
        var wordBefore = param.wordBefore, wordAfter = param.wordAfter;
        var _obj;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: "whitespace-nowrap break-all",
            children: [
                wordBefore && " ".concat(wordBefore),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("inline text-current", iconSizeClasses[size], (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "mr-2", wordAfter), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "ml-2", wordBefore), _obj)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_images_IconLoader__WEBPACK_IMPORTED_MODULE_3__/* .IconLoader */ .p, {
                        icon: icon,
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("inline-block translate-y-1", iconSizeClasses[size])
                    })
                }),
                wordAfter && "".concat(wordAfter, " ")
            ]
        });
    } : null;
    var _obj;
    var sharedClasses = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "pyxis-btn", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, sizeClasses[size], true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, variantClasses[variant], true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "pyxis-btn-alt", alt), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "inline-flex items-center justify-center", !stretch), _obj);
    // icon only button
    if (!(label === null || label === void 0 ? void 0 : label.trim().length)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            "aria-label": ariaLabel || label,
            onClick: handleClick,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(sharedClasses, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, iconOnlySizeClasses[size], !compact)),
                children: [
                    ButtonIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonIcon, {}),
                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonLoader, {})
                ]
            })
        }));
    }
    // icon + text button
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
        "aria-label": ariaLabel || label,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(sharedClasses, sizeClasses[size], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, "w-full flex", stretch)),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-left break-words",
                children: ButtonIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        ButtonIcon && iconPosition === "before" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonIcon, {
                            wordAfter: labelWords[0]
                        }),
                        iconPosition === "before" ? labelWords.slice(1).join(" ") : labelWords.slice(0, -1).join(" "),
                        ButtonIcon && iconPosition === "after" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonIcon, {
                            wordBefore: labelWords[labelWords.length - 1]
                        }),
                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonLoader, {})
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "flex",
                    children: [
                        label,
                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonLoader, {})
                    ]
                })
            })
        })
    }));
};
var ButtonLoader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "h-5 w-5 inline-flex self-center align-middle ml-2 -mb-1",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_loaders_Spinner__WEBPACK_IMPORTED_MODULE_4__/* .Spinner */ .$, {})
    });
};


/***/ }),

/***/ 12901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ ButtonGroup; }
/* harmony export */ });
/* unused harmony export ButtonGroupMemo */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14251);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90231);






var ButtonGroup = function(param) {
    var items = param.items, direction = param.direction, stretch = param.stretch, align = param.align, className = param.className;
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex-wrap gap-3 md:gap-4", (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "flex-col", direction === "vertical"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "inline-flex", !stretch), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "flex w-full", stretch), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "justify-start", direction === "horizontal" && align === "left"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "justify-center", direction === "horizontal" && align === "center"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "justify-end", direction === "horizontal" && align === "right"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "items-start", direction === "vertical" && align === "left"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "items-center", direction === "vertical" && align === "center"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "items-end", direction === "vertical" && align === "right"), _obj), className),
        children: items === null || items === void 0 ? void 0 : items.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex-shrink-0 max-w-full", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, "w-full", item.stretch)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, item))
            }, item.label);
        })
    });
};
var ButtonGroupMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(ButtonGroup)));


/***/ }),

/***/ 38373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PortableText": function() { return /* binding */ PortableText_PortableText; },
  "default": function() { return /* binding */ content_PortableText; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@portabletext/react/dist/react-portable-text.mjs + 1 modules
var react_portable_text = __webpack_require__(94279);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./node_modules/@pyxis/react/dist/es/index.js
var es = __webpack_require__(98647);
// EXTERNAL MODULE: ./components/images/PyxisIcon.tsx
var PyxisIcon = __webpack_require__(38053);
;// CONCATENATED MODULE: ./components/Accordion/Accordion.tsx








var PortableText = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 38373));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38373)
            ];
        }
    }
});
var Accordion = function(_param) {
    var items = _param.items, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "items"
    ]);
    if (!Boolean(items === null || items === void 0 ? void 0 : items.filter(Boolean).length)) return null;
    var defaultExpanded = rest.defaultExpanded || items.filter(function(param) {
        var defaultExpanded = param.defaultExpanded;
        return Boolean(defaultExpanded);
    }).map(function(param) {
        var title = param.title;
        return title;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es.Accordion, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        defaultExpanded: defaultExpanded,
        children: items === null || items === void 0 ? void 0 : items.map(function(item) {
            return /*#__PURE__*/ (0,react.createElement)(es.Accordion.Item, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                id: item.title,
                key: item.title,
                addon: item.icon ? function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PyxisIcon/* default */.ZP, {
                        name: item.icon
                    });
                } : item.addon
            }), /*#__PURE__*/ (0,jsx_runtime.jsx)(PortableText, {
                content: item.content
            }));
        })
    }));
};
/* harmony default export */ var Accordion_Accordion = (Accordion);

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./context/PageContext.ts
var PageContext = __webpack_require__(43470);
;// CONCATENATED MODULE: ./helpers/utils/file.ts
function getFileType(url) {
    if (!url) return null;
    var splitted = url.split(/[#?]/)[0].split(".");
    if (!url.startsWith("/") && splitted.length === 3) return null;
    return splitted.pop().trim();
}
function formatBytes(bytes) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (!+bytes) return null;
    var k = 1024;
    var dm = decimals < 0 ? 0 : decimals;
    var sizes = [
        "Bytes",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
    ];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return "".concat(parseFloat((bytes / Math.pow(k, i)).toFixed(dm)), " ").concat(sizes[i]);
}

// EXTERNAL MODULE: ./components/buttons/Button.tsx
var Button = __webpack_require__(90231);
// EXTERNAL MODULE: ./components/buttons/Link.tsx
var Link = __webpack_require__(76609);
;// CONCATENATED MODULE: ./components/Downloads/Downloads.tsx








var ITEMS_PER_PAGE = 6;
var Downloads = function(param) {
    var items = param.items;
    var ref;
    var ref1 = (0,react.useContext)(PageContext/* PageContext */.z), config = ref1.config, locale = ref1.locale;
    var translations = config.translations;
    var ref2 = (0,react.useState)(1), currentPage = ref2[0], setCurrentPage = ref2[1];
    if (!(items === null || items === void 0 ? void 0 : items.length)) return null;
    var filteredItems = (0,_to_consumable_array/* default */.Z)(items).slice(0, currentPage * ITEMS_PER_PAGE);
    var hasNext = items.length > currentPage * ITEMS_PER_PAGE;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "not-prose my-12 prose-media",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "flex flex-col gap-3 md:gap-0 p-0 m-0",
                children: filteredItems.filter(Boolean).map(function(param, index) {
                    var title = param.title, link = param.link, file = param.file, filesize = param.filesize, filename = param.filename;
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                        className: classnames_default()("relative rounded-xl px-4 md:px-8 py-4 md:py-6 group w-full", "transition-all hover:shadow-lg focus-within:shadow-lg duration-500", "shadow-lg md:shadow-none", "bg-white md:bg-transparent", "hover:bg-white focus-within:bg-white hover:z-10", "flex flex-col md:flex-row gap-2 md:gap-8 md:items-center text-left", "md:-mt-0.5"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                                        href: file || link,
                                        className: "outline-none",
                                        download: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "absolute inset-0 bg-neutral-25 block opacity-0 z-10 cursor-pointer"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: title
                                            })
                                        ]
                                    }),
                                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: classnames_default()("font-bold text-neutral-base text-title-sm-sm md:text-title-md-md lg:text-title-md-lg", "group-hover:underline group-focus-within:underline underline-offset-4 md:group-hover:no-underline md:group-focus-within:no-underline"),
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-bold text-title-sm-sm md:text-title-sm-md lg:text-title-sm-lg text-brand-base uppercase",
                                        children: [
                                            getFileType(filename || link),
                                            formatBytes(filesize)
                                        ].filter(Boolean).join(", ")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:ml-auto shrink-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    as: "span",
                                    label: (translations === null || translations === void 0 ? void 0 : (ref = translations.download_list_button) === null || ref === void 0 ? void 0 : ref[locale]) || "Download",
                                    variant: "secondary"
                                })
                            }),
                            index !== (items === null || items === void 0 ? void 0 : items.length) - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "hidden md:block h-0.5 bg-neutral-85 absolute left-0 right-0 bottom-0 group-hover:opacity-0 transition-opacity duration-500"
                            }),
                            index > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "hidden md:block h-0.5 bg-neutral-95 absolute left-0 right-0 top-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                            })
                        ]
                    }, title);
                })
            }),
            hasNext && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center my-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    label: translations === null || translations === void 0 ? void 0 : (ref = translations.download_list_show_more) === null || ref === void 0 ? void 0 : ref[locale],
                    onClick: function() {
                        return setCurrentPage(function(n) {
                            return n + 1;
                        });
                    }
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./helpers/utils/string.ts
var string = __webpack_require__(80109);
;// CONCATENATED MODULE: ./components/buttons/Linkify.tsx


/**
 * Change link like text to anchors, e.g https://google.com becomes a clickable link
 * used for data from an external source in the table component
 */ var Linkify = function(param) {
    var children = param.children;
    var config = [
        {
            regex: /(http|https):\/\/(\S+)\.([a-z]{2,}?)(.*?)( |\,|$|\.)/gim,
            fn: function(key, result) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "underline",
                            target: "_blank",
                            rel: "noreferrer",
                            href: "".concat(result[1], "://").concat(result[2], ".").concat(result[3]).concat(result[4]),
                            children: [
                                result[2],
                                ".",
                                result[3],
                                result[4]
                            ]
                        }),
                        result[5]
                    ]
                }, key);
            }
        }, 
    ];
    var processed = (0,string/* processString */.Pl)(config)(children);
    return processed;
};

// EXTERNAL MODULE: ./components/loaders/Spinner.tsx
var Spinner = __webpack_require__(58998);
;// CONCATENATED MODULE: ./components/Table/Table.tsx






var Table = function(param) {
    var file = param.file, fileName = param.fileName;
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(null), data = ref3[0], setData = ref3[1];
    var ref4 = (0,react.useState)("loading"), state = ref4[0], setState = ref4[1];
    (0,react.useEffect)(function() {
        if (!file) return;
        setState("loading");
        function load() {
            return _load.apply(this, arguments);
        }
        function _load() {
            _load = (0,_async_to_generator/* default */.Z)(function() {
                var Papa;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                __webpack_require__.e(/* import() */ 460).then(__webpack_require__.t.bind(__webpack_require__, 57460, 23))
                            ];
                        case 1:
                            Papa = _state.sent().default;
                            Papa.parse(file, {
                                download: true,
                                header: true,
                                error: function(err) {
                                    console.log(err);
                                    setState("error");
                                },
                                complete: function complete(results) {
                                    var ref;
                                    if ((ref = results.errors) === null || ref === void 0 ? void 0 : ref.length) {
                                        console.log(results);
                                        return setState("error");
                                    }
                                    setData(results);
                                    setState("complete");
                                }
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return _load.apply(this, arguments);
        }
        load();
    }, [
        file
    ]);
    if (state === "loading") return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex gap-2 items-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-5 h-5",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {})
        })
    });
    if (state === "error") return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "",
        children: [
            "Something went wrong. Click here to download",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: file,
                download: true,
                className: "underline",
                children: fileName
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "overflow-x-auto not-prose",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "text-sm sm:text-md min-w-[500px]",
            children: data && /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                className: "border border-collapse table-auto w-full",
                children: [
                    data.meta.fields.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                            children: (ref = data.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.map(function(field) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    className: "align-top border-b p-4 text-left",
                                    children: field
                                }, field);
                            })
                        })
                    }),
                    data.data.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: data === null || data === void 0 ? void 0 : (ref2 = data.data) === null || ref2 === void 0 ? void 0 : ref2.map(function(row) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                className: "even:bg-[rgba(0,0,0,.025)]",
                                children: Object.keys(row).map(function(key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "align-top border-b p-4 text-left",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Linkify, {
                                            children: row[key]
                                        })
                                    }, key);
                                })
                            }, JSON.stringify(row));
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/buttons/ButtonCardGroup.tsx





var ButtonCardGroup = function(param) {
    var items = param.items;
    if (!Boolean(items === null || items === void 0 ? void 0 : items.filter(Boolean).length)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex gap-4 flex-wrap",
        children: items === null || items === void 0 ? void 0 : items.map(function(item) {
            var icon = item.icon;
            if (!icon) {
                var ref, ref1, ref2;
                if ((ref = item.link) === null || ref === void 0 ? void 0 : (ref1 = ref.href) === null || ref1 === void 0 ? void 0 : ref1.startsWith("http")) icon = "IconExternalLink";
                if ((ref2 = item.link) === null || ref2 === void 0 ? void 0 : ref2.download) icon = "IconDownload";
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(es.ButtonCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item.link), {
                icon: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PyxisIcon/* default */.ZP, {
                        name: icon,
                        size: "l"
                    });
                },
                children: item.children || item.title
            }), item.title);
        })
    });
};

// EXTERNAL MODULE: ./components/buttons/ButtonGroup.tsx
var ButtonGroup = __webpack_require__(12901);
;// CONCATENATED MODULE: ./components/images/FigCaption.tsx



var FigCaption = function(param) {
    var caption = param.caption, className = param.className;
    if (!(caption === null || caption === void 0 ? void 0 : caption.trim().length)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
        className: classnames_default()("mt-3 text-left text-md leading-relaxed prose-current text-neutral-25", className),
        children: caption
    });
};
/* harmony default export */ var images_FigCaption = (/*#__PURE__*/react.memo(FigCaption));

// EXTERNAL MODULE: ./components/images/IconLoader.tsx
var IconLoader = __webpack_require__(64162);
// EXTERNAL MODULE: ./components/images/ZoomableImage.tsx
var ZoomableImage = __webpack_require__(81533);
;// CONCATENATED MODULE: ./components/content/PortableTextOptions.ts
var SCRIPT_OPTIONS = {
    CookieDeclaration: "Cookie Declaration"
};
var SCRIPTS = {
    CookieDeclaration: {
        id: "CookieDeclaration",
        src: "https://consent.cookiebot.com/e28f9653-5a8d-478d-8764-010b3403cad0/cd.js",
        async: true,
        wrapperId: "CookieDeclaration"
    }
};

;// CONCATENATED MODULE: ./components/content/PortableText.tsx

















var Video = dynamic_default()(function() {
    return Promise.all(/* import() | VideoComponent */[__webpack_require__.e(132), __webpack_require__.e(637)]).then(__webpack_require__.bind(__webpack_require__, 85289));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85289)
            ];
        }
    }
});
var PortableText_PortableText = function(param) {
    var _content = param.content, content = _content === void 0 ? [] : _content;
    if (!content) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_portable_text/* PortableText */.YI, {
        value: content,
        components: {
            block: {
                small: function(param) {
                    var children = param.children;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "prose-sm",
                        children: children
                    });
                }
            },
            marks: {
                link: function(param) {
                    var value = param.value, children = param.children;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        href: value.href,
                        locale: value.language,
                        target: value.target,
                        children: children
                    });
                }
            },
            list: {
                bullet: function(param) {
                    var children = param.children;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: children
                    });
                },
                number: function(param) {
                    var children = param.children;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                        children: children
                    });
                }
            },
            types: {
                "image.simple": function(param) {
                    var value = param.value;
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "not-prose my-8 md:my-12 lg:my-16 [&:first-child]:!mt-0 prose-media",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ZoomableImage/* ZoomableImage */.X, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                                    enabled: value.zoomable
                                })),
                                (value === null || value === void 0 ? void 0 : (ref = value.image) === null || ref === void 0 ? void 0 : ref.src) && (value === null || value === void 0 ? void 0 : value.downloadable) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "".concat(value.image.src, "?dl"),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    download: true,
                                    className: "group ml-3 mb-2 mt-3 inline-block float-right border-2 border-action-base hover:border-action-dark transition-colors rounded-full inline-flex p-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLoader/* IconLoader */.p, {
                                        icon: "download",
                                        className: "w-5 h-5 text-action-base group-hover:text-action-dark transition-colors block"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(images_FigCaption, {
                                    caption: value.caption,
                                    className: "pl-10 md:pl-16 lg:pl-0"
                                })
                            ]
                        })
                    });
                },
                video: function video(param) {
                    var value = param.value;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "not-prose my-8 md:my-12 lg:my-16 prose-media",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Video, (0,_object_spread/* default */.Z)({}, value.video)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(images_FigCaption, {
                                    caption: value.caption
                                })
                            ]
                        })
                    });
                },
                buttons: function buttons(param) {
                    var value = param.value;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "not-prose my-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup/* ButtonGroup */.i, (0,_object_spread/* default */.Z)({}, value))
                    });
                },
                csv: function csv(param) {
                    var value = param.value;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Table, (0,_object_spread/* default */.Z)({}, value));
                },
                downloads: function downloads(param) {
                    var value = param.value;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Downloads, (0,_object_spread/* default */.Z)({}, value));
                },
                scripts: function scripts(param) {
                    var value = param.value;
                    var ref;
                    if (!SCRIPTS[value === null || value === void 0 ? void 0 : value.scriptId]) return null;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: (ref = SCRIPTS[value === null || value === void 0 ? void 0 : value.scriptId]) === null || ref === void 0 ? void 0 : ref.wrapperId,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), (0,_object_spread/* default */.Z)({}, SCRIPTS[value === null || value === void 0 ? void 0 : value.scriptId]))
                    });
                },
                accordion: function accordion(param) {
                    var value = param.value;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "not-prose my-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion_Accordion, (0,_object_spread/* default */.Z)({}, value))
                    });
                },
                buttonCardGroup: function buttonCardGroup(param) {
                    var value = param.value;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "not-prose my-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCardGroup, (0,_object_spread/* default */.Z)({}, value))
                    });
                }
            }
        }
    });
};
/* harmony default export */ var content_PortableText = (/*#__PURE__*/react.memo(PortableText_PortableText));


/***/ }),

/***/ 81533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ZoomableImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44747);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26126);
/* harmony import */ var _ResponsiveImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6893);







var ZoomableImage = function(param) {
    var enabled = param.enabled, image = param.image;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), zoomEnabled = ref[0], setZoomEnabled = ref[1];
    if (!image) return null;
    if (!enabled) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ResponsiveImage__WEBPACK_IMPORTED_MODULE_3__/* .ResponsiveImage */ .t3, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, image));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_2__/* .TransformWrapper */ .d$, {
        disabled: !enabled || !zoomEnabled,
        maxScale: 3,
        children: function(_param) /*#__PURE__*/ {
            var zoomIn = _param.zoomIn, resetTransform = _param.resetTransform, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
                "zoomIn",
                "resetTransform"
            ]);
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "cursor-zoom-in",
                onClick: function() {
                    if (zoomEnabled) return;
                    setZoomEnabled(true);
                    zoomIn();
                },
                onMouseLeave: function() {
                    setZoomEnabled(false);
                    resetTransform();
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_2__/* .TransformComponent */ .Uv, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ResponsiveImage__WEBPACK_IMPORTED_MODULE_3__/* .ResponsiveImage */ .t3, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, image), {
                        dpr: 3,
                        className: "point-events-none select-none"
                    }))
                })
            });
        }
    });
};


/***/ })

}]);